<template>
  <b-form @submit.prevent="submitForm">
    <b-row class="mb-1 py-2 font-weight-bolder bg-light">
      <b-col md="2">
        Analyte
      </b-col>
      <b-col>
        Feed Type
      </b-col>
      <b-col md="2">
        Low
      </b-col>
      <b-col md="2">
        High
      </b-col>
    </b-row>

    <b-row class="mb-2 py-2 align-items-center">
      <b-col md="2">
        {{ analyte.name }}
      </b-col>

      <b-col>
        <b-form-select
          v-model="form_data.attribute_list_id"
          :options="feed_options"
        >
          <template #first>
            <option :value="null">
              Select Feed Type
            </option>
          </template>
        </b-form-select>
      </b-col>

      <b-col md="2">
        <b-form-input
          v-model="form_data.low"
          type="text"
          placeholder="Low"
        />
      </b-col>

      <b-col md="2">
        <b-form-input
          v-model="form_data.high"
          type="text"
          placeholder="High"
        />
      </b-col>
    </b-row>

    <div class="d-flex justify-content-end">
      <b-button variant="danger" class="mx-2" @click="$emit('close')">
        Cancel
      </b-button>
      <b-button variant="success" @click="submitForm">
        <i class="fa fa-save" /> Save
      </b-button>
    </div>
  </b-form>
</template>

<script>
import Vue from 'vue'
import VueNotifications from 'vue-notifications'
import AnalyteRangeRepository from '@/repositories/lab/AnalyteRangeRepository'
import { notificationOptions } from '@/shared/toast-notification-options'
import { analyteRangeNotifications } from '@/shared/notifications'

Vue.use(VueNotifications, notificationOptions)

export default {
  name: 'AnalyteRangeFormFeedAdd',
  props: {
    analyte: {
      type: Object,
      default: () => null
    },
    selected_attribute_list_value: {
      type: String,
      default: null
    },
    feed_options: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      form_data: {
        analyte_id: this.analyte.id,
        attribute_list_id: null,
        low: null,
        high: null
      },

      submitting: false
    }
  },
  created () {
    if (this.selected_attribute_list_value) {
      this.form_data.attribute_list_id = this.selected_attribute_list_value
    }
  },
  methods: {
    async submitForm () {
      this.submitting = true

      try {
        await AnalyteRangeRepository.create(this.form_data)

        this.addSuccess()
        this.$emit('saved')
      } catch (error) {
        console.error(error)
      }

      this.submitting = false
    }
  },
  notifications: analyteRangeNotifications
}
</script>
